function parseColorToRgb(color) {
  const s = String(color || "").trim();
  if (!s) return null;

  const rgbMatch = s.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (rgbMatch) {
    return { r: Number(rgbMatch[1]), g: Number(rgbMatch[2]), b: Number(rgbMatch[3]) };
  }

  let raw = s.replace("#", "");
  if (/^[0-9a-f]{3}$|^[0-9a-f]{6}$/i.test(raw)) {
    if (raw.length === 3) {
      raw = raw
        .split("")
        .map((c) => c + c)
        .join("");
    }
    return {
      r: parseInt(raw.slice(0, 2), 16),
      g: parseInt(raw.slice(2, 4), 16),
      b: parseInt(raw.slice(4, 6), 16),
    };
  }

  return null;
}

/** Mix a theme color toward white. `amount` 0 = original, 1 = white. */
export function lightenHexColor(hex, amount = 0.82) {
  const rgb = parseColorToRgb(hex);
  if (!rgb) return null;

  const mix = (channel) => Math.round(channel + (255 - channel) * amount);
  return `rgb(${mix(rgb.r)}, ${mix(rgb.g)}, ${mix(rgb.b)})`;
}

/** Returns "#ffffff" or "#1a1a1a" depending on which contrasts better with `color`. */
export function readableTextColor(color, dark = "#1a1a1a", light = "#ffffff") {
  const rgb = parseColorToRgb(color);
  if (!rgb) return dark;
  // Perceived luminance (sRGB) — threshold ~0.6 keeps text white on most banners.
  const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
  return luminance > 0.6 ? dark : light;
}

export function themeButtonBackground(themeData) {
  if (!themeData) return null;
  return (
    themeData.button_backgroundcolor ||
    themeData.button_background_color ||
    null
  );
}

export function themeButtonTextColor(themeData) {
  if (!themeData) return null;
  return themeData.button_color || themeData.button_text_color || null;
}

/** Light panel/modal fill derived from admin button background. */
export function themeSurfaceBackground(themeData, amount = 0.82) {
  const btn = themeButtonBackground(themeData);
  return btn ? lightenHexColor(btn, amount) : null;
}

/** Inline style for themed gallery/leaderboard surfaces (shared CSS variable + color). */
export function themeSurfaceStyle(themeData, amount = 0.82) {
  const bg = themeSurfaceBackground(themeData, amount);
  if (!bg) return undefined;
  return { "--yg-surface-bg": bg, backgroundColor: bg };
}
